export default __webpack_public_path__ + "static/jobbox1-1557522efbf07f25abd06e8a65b96b96.webp";